var _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 19V19.75H7H21H21.75V19V17.25C21.75 16.3927 21.3146 15.6972 20.7435 15.1701C20.1774 14.6477 19.4298 14.2413 18.655 13.931C17.1067 13.3107 15.2619 13 14 13C12.7381 13 10.8933 13.3107 9.345 13.931C8.57025 14.2413 7.82256 14.6477 7.25654 15.1701C6.68543 15.6972 6.25 16.3927 6.25 17.25V19ZM14 12.75C16.348 12.75 18.25 10.848 18.25 8.5C18.25 6.15204 16.348 4.25 14 4.25C11.652 4.25 9.75 6.15204 9.75 8.5C9.75 10.848 11.652 12.75 14 12.75Z",
    stroke: "#181818",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 7,
    width: 6,
    height: 1.5,
    transform: "rotate(90 4.5 7)",
    fill: "#181818"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.75,
    y: 10.75,
    width: 6,
    height: 1.5,
    transform: "rotate(-180 6.75 10.75)",
    fill: "#181818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUsers);
export default __webpack_public_path__ + "static/media/Add_users.afdbaa1f9f77c26597d46c90341deff1.svg";
export { ForwardRef as ReactComponent };